import React from 'react';
import AnimatedButton from './AnimatedButton';
import SecondaryButton from './SecondaryButton';
import Counter from './Counter';
import Reveal from './Reveal';
import WordReveal from './WordReveal';

interface HeroProps {
  onInvestorClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onInvestorClick }) => {
  const waLink = "https://wa.me/5573998595834?text=Olá,%20gostaria%20de%20mais%20informações";

  return (
    <section id="inicio" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-white">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://i.imgur.com/enHl71N.jpeg" 
          alt="Solar Plant Background" 
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 grid lg:grid-cols-2 gap-12 items-center">
        <div className="max-w-2xl space-y-8">
          <Reveal delay={100}>
            <div className="flex items-center space-x-3">
              <div className="inline-flex items-center space-x-2 px-4 py-2 bg-gray-50 border border-gray-100 rounded-full shadow-sm">
                <span className="w-2 h-2 rounded-full bg-[#39B54A] animate-pulse"></span>
                <span className="text-[10px] font-black tracking-[0.2em] text-gray-500 uppercase">Sustentabilidade guiada por inteligência artificial</span>
              </div>
              <button 
                onClick={onInvestorClick}
                className="text-[10px] font-black text-[#39B54A] border-b-2 border-[#39B54A] pb-1 hover:opacity-70 transition-opacity uppercase tracking-widest"
              >
                Investidores →
              </button>
            </div>
          </Reveal>
          
          <div className="text-5xl md:text-7xl font-extrabold text-gray-900 leading-[1.1]">
            <WordReveal 
              text="Economize até 84% na sua conta de energia." 
              delay={300} 
              stagger={100} 
            />
          </div>
          
          <div className="text-lg md:text-xl text-gray-600 font-medium leading-relaxed">
            <WordReveal 
              text="Módulos inteligentes de nova geração com gestão por IA. Transforme seu investimento em rendimento máximo e sustentabilidade real." 
              delay={1000} 
              stagger={40} 
            />
          </div>
          
          <Reveal delay={1800}>
            <div className="flex flex-col sm:flex-row gap-4">
              <AnimatedButton 
                text="Falar com especialista" 
                href={waLink} 
                className="!px-12 !py-5"
              />
              <SecondaryButton 
                text="Ver soluções"
                href="#solucoes"
                className="px-10 py-5"
              />
            </div>
          </Reveal>

          <Reveal delay={2200}>
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-100">
              <div className="space-y-2">
                <p className="text-4xl md:text-5xl font-black text-gray-900">
                  <Counter value="100%" duration={7000} delay={3000} />
                </p>
                <div className="text-xs text-gray-400 tracking-wider font-bold">
                  <WordReveal text="Energia limpa" delay={2400} stagger={60} />
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-4xl md:text-5xl font-black text-gray-900">
                  <Counter value="+15" duration={7000} delay={3200} />
                </p>
                <div className="text-xs text-gray-400 tracking-wider font-bold">
                  <WordReveal text="Cidades atendidas" delay={2600} stagger={60} />
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-4xl md:text-5xl font-black text-gray-900">
                  <Counter value="-84%" duration={7000} delay={3400} />
                </p>
                <div className="text-xs text-gray-400 tracking-wider font-bold">
                  <WordReveal text="Custos" delay={2800} stagger={60} />
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="hidden lg:block relative">
          <Reveal delay={500}>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#39B54A]/5 rounded-full blur-[100px]"></div>
            <div className="relative p-4 rounded-3xl overflow-hidden shadow-2xl rotate-2 bg-white/10 backdrop-blur-sm border border-white/20">
              <img 
                src="https://i.imgur.com/oxg4tul.jpeg" 
                className="rounded-2xl w-full h-auto shadow-inner"
                alt="Instalação Solar Energy Solaris"
              />
              {/* MINI TEXTO COM FUNDO BRANCO RETANGULAR */}
              <div className="absolute bottom-10 left-10 p-5 bg-white rounded-2xl border-l-[6px] border-[#39B54A] shadow-[0_15px_40px_rgba(0,0,0,0.15)] transform -rotate-2">
                <p className="text-gray-900 font-black text-lg leading-tight">Tecnologia N-Type + IA</p>
                <p className="text-[#39B54A] text-xs font-black uppercase tracking-widest mt-1">Gestão inteligente de rendimento</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Hero;